import { render, staticRenderFns } from "./PersonPerformanceEdit.vue?vue&type=template&id=69c9a6bc&scoped=true&"
import script from "./PersonPerformanceEdit.vue?vue&type=script&lang=js&"
export * from "./PersonPerformanceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c9a6bc",
  null
  
)

export default component.exports